// const baseUrl = "https://dev.valianttinfo.com/valiantinfo_app/";
const baseUrl = "https://api.valianttinfo.com/valiantinfo_app/";
const payBaseUrl = "https://api.valianttinfo.com/"
export { baseUrl,payBaseUrl };
